import { fork } from 'redux-saga/effects';

import { authSaga } from '../actions/auth';
import { usersSaga } from '../actions/users';
import { documentsSaga } from '../actions/documents';
import { sectionsSaga } from '../actions/sections';

export default function* mainSaga() {
    yield fork(authSaga);
    yield fork(usersSaga);
    yield fork(documentsSaga);
    yield fork(sectionsSaga);
}
